<template>
  <div>
    <subtle-heading>PLATTFORM</subtle-heading>
    <prominent-list-item :imgUrl="content.ams.imgUrl" :title="content.ams.name">
      <template v-slot:action>
        <i>Kommer snart</i>
        <!-- <v-switch
          color="open"
          v-model="jobPostingValue.ams.published"
          inset
        ></v-switch> -->
      </template>
      <v-slot></v-slot
    ></prominent-list-item>
    <v-divider></v-divider>
    <prominent-list-item
      :imgUrl="content.blocketjobs.imgUrl"
      :title="content.blocketjobs.name"
    >
      <template v-slot:action>
        <i>Kommer snart</i>
        <!--  <v-switch
          color="open"
          v-model="jobPostingValue.blocketjobs.published"
          inset
        ></v-switch> -->
      </template>
      <v-slot></v-slot
    ></prominent-list-item>
    <v-divider></v-divider>
    <prominent-list-item
      :imgUrl="content.briteLink.imgUrl"
      :title="content.briteLink.name"
    >
      <template v-slot:action>
        <div>
          <v-tooltip v-model="showApplicationLinkCopiedTooltip" top>
            <template v-slot:activator="{ ondisabled, attrsdisabled }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="copyApplicationLink" v-bind="attrs" v-on="on"
                    >content_copy</v-icon
                  >
                </template>
                <span>Kopiera</span>
              </v-tooltip>
            </template>
            <span>Kopierad</span>
          </v-tooltip>
        </div>
      </template>
    </prominent-list-item>
    <hidden-offscreen>
      <v-text-field
        ref="applicationLink"
        :value="applicationLink"
      ></v-text-field>
    </hidden-offscreen>
    <v-divider></v-divider>
  </div>
</template>

<script>
import SubtleHeading from "../atom/heading/SubtleHeading";
import basicMixin from "../../mixins/basic";
import HiddenOffscreen from "../atom/misc/HiddenOffscreen.vue";
import { sleep } from "../../utils/misc";

export default {
  components: { HiddenOffscreen, SubtleHeading },
  mixins: [basicMixin],
  props: {
    jobGuid: {
      type: String,
      default: null,
    },
    jobPosting: {
      type: Object,
      default() {},
    },
  },
  mounted: function () {
    if (this.jobPosting != undefined) {
      this.jobPostingValue = JSON.parse(JSON.stringify(this.jobPosting));
    }
  },
  data: function () {
    return {
      showApplicationLinkCopiedTooltip: false,
      jobPostingValue: {
        ams: { published: false },
        blocketjobs: { published: false },
      },
      content: {
        ams: {
          name: "Publicera på Arbetsförmedlingen",
          imgUrl:
            "data:image/png;base64,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",
        },
        blocketjobs: {
          name: "Publicera på Blocket Jobs",
          imgUrl:
            "https://jobb.blocket.se/img/blocket_jobb_2021_logo_col.svg",
        },
        linkedin: {
          name: "Välj plan",
          imgUrl:
            "https://storage.googleapis.com/brite-resources/logo/Brite_logo_teal%404x.png",
        },
        briteLink: {
          name: "Länk för delning, annonser, etc.",
          imgUrl:
            "https://storage.googleapis.com/brite-resources/logo/Brite_logo_teal%404x.png",
        },
      },
    };
  },
  methods: {
    copyApplicationLink: async function () {
      let textToCopy = this.$refs.applicationLink.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");

      this.showApplicationLinkCopied = true;
      this.showApplicationLinkCopiedTooltip = true;
      await sleep(2000);
      this.showApplicationLinkCopiedTooltip = false;
    },
  },

  computed: {
    applicationLink: function () {
      var baseURL = "https://my.brite.jobs/signup?job=";
      if (process.env.NODE_ENV == "development") {
        baseURL = "https://at-dev-brite.web.app/signup?job=";
      }
      if (process.env.NODE_ENV == "demo") {
        baseURL = "https://at-demo-brite.web.app/signup?job=";
      }
      if (process.env.NODE_ENV == "staging") {
        baseURL = "https://at-staging-brite.web.app/signup?job=";
      }
      return baseURL + this.jobGuid;
    },
  },
  watch: {
    jobPostingValue: {
      handler: function () {
        this.$emit("update:jobPosting", this.jobPostingValue);
      },
      deep: true,
    },
  },
};
</script>

<style></style>
